import { render, staticRenderFns } from "./ShipperOrgItemEditPage.vue?vue&type=template&id=4225ec72&"
import script from "./ShipperOrgItemEditPage.vue?vue&type=script&lang=js&"
export * from "./ShipperOrgItemEditPage.vue?vue&type=script&lang=js&"
import style0 from "./ShipperOrgItemEditPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports